import { createContext } from "react";
import { LANG } from "config/const";

const LanguageContext = createContext({ lang: LANG.TH, setLang: () => {} });

export default LanguageContext;
